import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'alt_calendar';
export const route = 'alt_calendar/[[...token]]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "alt_calendar" */
/* webpackPrefetch: true */
'../components/AltMobileCalendarPage')));